import { render, staticRenderFns } from "./ComplaintTypeChart.vue?vue&type=template&id=1a76471c&"
import script from "./ComplaintTypeChart.vue?vue&type=script&lang=ts&"
export * from "./ComplaintTypeChart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports